<template>
    <form @submit.prevent="submitForm">
        <div class="form-control" :class="{invalid: !firstName.isValid}">
            <label>First Name</label>
            <input type="text" id="firstName" v-model.trim="firstName.val" @blur="clearValidity('firstName')" />
            <p v-if="!firstName.isValid">Fill in First Name</p>
        </div>
        <div class="form-control" :class="{invalid:!lastName.isValid}">
            <label>Last Name</label>
            <input type="text" id="lastName" v-model.trim="lastName.val" @blur="clearValidity('lastName')" />
            <p v-if="!lastName.isValid">Fill in Last Name</p>
        </div>
        <div class="form-control" :class="{invalid: !description.isValid}">
            <label>Description</label>
            <textarea id="description" row="5" v-model.trim="description.val" @blur="clearValidity('description')"></textarea>
            <p v-if="!description.isValid">Fill in Description</p>
        </div>
        <div class="form-control" :class="{invalid: !rate.isValid}">
            <label>Hourly Rate</label>
            <input type="number" id="rate" v-model.number="rate.val" @blur="clearValidity('rate')" />
            <p v-if="!rate.isValid">Rate must be greater than 0</p>
        </div>
        <div class="form-control" :class="{invalid: !areas.isValid}">
            <h3>Areas of Expertise</h3>
            <div>
                <input type="checkbox" id="adhd" value="adhd" v-model="areas.val" @blur="clearValidity('areas')"/>
                <label for="adhd">ADHD</label>
            </div>
            <div>
                <input type="checkbox" id="anxiety" value="anxiety" v-model="areas.val" @blur="clearValidity('areas')" />
                <label for="anxiety">Anxiety</label>
            </div>
            <div>
                <input type="checkbox" id="autism" value="autism" v-model="areas.val" @blur="clearValidity('areas')"/>
                <label for="autism">Autism</label>
            </div>
            <div>
                <input type="checkbox" id="depression" value="depression" v-model="areas.val" @blur="clearValidity('areas')" />
                <label for="depression">Depression</label>
            </div>
            <div>
                <input type="checkbox" id="did" value="did" v-model="areas.val" @blur="clearValidity('areas')"/>
                <label for="did">DID</label>
            </div>
            <p v-if="!areas.isValid">Areas cannot be empty</p>
        </div>
        <p v-if="!formIsValid">Please fix the above errors and try again</p>
        <base-button>Register</base-button>
    </form>
</template>

<script>
export default {
  emits: ['save-data'],
    data(){
        return {
            firstName: {
              val: '',
              isValid: true
            },
            lastName: {
              val: '',
              isValid: true
            },
            description: {
              val: '',
              isValid: true
            },
            rate: {
              val: null,
              isValid: true
            },
            areas: {
              val: [],
              isValid: true
            },
            formIsValid: true,
        };
    },
    methods: {
      clearValidity(input){
        this[input].isValid = true;
      },
      validateForm(){
        this.formIsValid = true;
        if(this.firstName.val === ''){
          this.firstName.isValid = false;
          this.formIsValid = false;
        }
        if(this.lastName.val === ''){
          this.lastName.isValid = false;
          this.formIsValid = false;
        }
        if(this.description.val === ''){
          this.description.isValid = false;
          this.formIsValid = false;
        }
        if(!this.rate.val || this.rate.val < 0){
          this.rate.isValid = false;
          this.formIsValid = false;
        }
        if(this.areas.val.length === 0){
          this.areas.isValid = false;
          this.formIsValid = false;
        }
      },
      submitForm(){
        this.validateForm();

        if (!this.formIsValid){
          return;
        }
        const formData = {
            first: this.firstName.val,
            last: this.lastName.val,
            desc: this.description.val,
            rate: this.rate.val,
            areas: this.areas.val
        };
        // console.log(formData);
        this.$emit('save-data', formData);
      }
    }
}
</script>

<style scoped>
.form-control {
  margin: 0.5rem 0;
}

label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input[type='checkbox'] + label {
  font-weight: normal;
  display: inline;
  margin: 0 0 0 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  border: 1px solid #798777;
  font: inherit;
}

input:focus,
textarea:focus {
  background-color: #F8EDE3;
  outline: none;
  border-color: #798777;
}

input[type='checkbox'] {
  display: inline;
  width: auto;
  border: none;
}

input[type='checkbox']:focus {
  outline: #798777 solid 1px;
}

h3 {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.invalid label {
  color: #FFC286;
}

.invalid input,
.invalid textarea {
  border: 1px solid #FFC286;
}
</style>